import { useAuthenticatedUser } from '../hooks/useAuthenticatedUser';
import { API_METHOD } from '../utils/constant';
import { request } from '.';
import { replaceUrlParams } from '../utils/helper';

const MATERIAL_REQUIREMENT_URLS = {
    PUT_MATERIAL_REQUIREMENT_OTHER_PREFERENCE: "/material-requirement-other-preference/:section/:userId",
    GET_MATERIAL_REQUIREMENT_OTHER_PREFERENCE_BY_ID: "/material-requirement-other-preference/:userId",
}

export interface IMaterialRequirementOtherPreference {
    customization: string[],
    preferredDeliveryLocation: string[],
    preferredDeliveryTime: string,
    tradeType: string,
}

interface IMaterialRequirementBrandManufacturer {
    brands: string[],
    manufacturerIds: number[]
}

interface IPreferredProductCategory {
    productCategories: number[],
}

export const useMaterialRequirementOtherPreferenceService = () => {
    const { user: authenticatedUser } = useAuthenticatedUser();

    const getMaterialRequirementOtherPreference = (userId: number) => {
        return request(API_METHOD.GET, replaceUrlParams(MATERIAL_REQUIREMENT_URLS.GET_MATERIAL_REQUIREMENT_OTHER_PREFERENCE_BY_ID, { userId }), authenticatedUser, null);
    };

    const updateMaterialRequirementsOtherPreference = (data: IMaterialRequirementOtherPreference | IMaterialRequirementBrandManufacturer | IPreferredProductCategory, section: string, userId: number) => {
        return request(API_METHOD.PUT, replaceUrlParams(MATERIAL_REQUIREMENT_URLS.PUT_MATERIAL_REQUIREMENT_OTHER_PREFERENCE, {section, userId}), authenticatedUser, data);
    };
    return {
        updateMaterialRequirementsOtherPreference,
        getMaterialRequirementOtherPreference,
    };
};
